import { render, staticRenderFns } from "./ventures.vue?vue&type=template&id=faf41d30&scoped=true"
import script from "./ventures.vue?vue&type=script&lang=js"
export * from "./ventures.vue?vue&type=script&lang=js"
import style0 from "./ventures.vue?vue&type=style&index=0&id=faf41d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf41d30",
  null
  
)

export default component.exports